// extracted by mini-css-extract-plugin
export default {"container":"home-page-mollo_container__B9WaQ","blocks":"home-page-mollo_blocks__10U6Z"};